import { useEffect, useState } from "react";
import { readFlag, writeFlag } from "../../hooks/usePortal";

export const ENTER_FLAG = "hacams.portal.enter";

// A brief warm light that fades away after a successful sign-in, as the studio opens up.
export default function EntranceFlash() {
  const [on, setOn] = useState(() => readFlag(ENTER_FLAG));
  useEffect(() => {
    if (!on) return undefined;
    writeFlag(ENTER_FLAG, false);
    const timer = window.setTimeout(() => setOn(false), 1600);
    return () => window.clearTimeout(timer);
  }, [on]);
  return on ? <div className="pt-enter-flash" aria-hidden="true" /> : null;
}
